import React from 'react';
import { featuredFilm } from '../mockData';
import { Button } from './ui/button';

const FeaturedSection = () => {
  return (
    <section className="bg-black text-white py-16 sm:py-24 md:py-32 relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Left Side - Image */}
          <div className="relative rounded-lg overflow-hidden order-2 lg:order-1">
            <img
              src="https://customer-assets.emergentagent.com/job_oriental-cinema/artifacts/0c97v74e_659889999_17921102304293745_4607221479103846510_n.jpg"
              alt="GAFF27 - Introducing Short Films"
              className="w-full h-auto object-contain" />
          </div>

          {/* Right Side - Content */}
          <div className="space-y-6 sm:space-y-8 order-1 lg:order-2">
            <div className="relative">
              {/* Red Asterisk Decoration */}
              <div className="absolute -top-8 -right-8 sm:-top-10 sm:-right-10 text-red-500 text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-bold opacity-20">
                *
              </div>

              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-8xl font-bold leading-none mb-4 sm:mb-6">
                INTRODUCING
              </h2>
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-8xl font-bold leading-none text-red-500 mb-6 sm:mb-8">
                SHORTS
              </h2>
            </div>

            <div className="space-y-3 sm:space-y-4 text-gray-400">
              <p className="text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed text-gray-300">
                For the first time, GAFF is accepting <span className="text-white font-semibold">short films</span> for the 2027 edition. Less time, more impact – discover powerful storytelling in compact form.
              </p>
              <p className="text-sm sm:text-base md:text-lg">
                Asian Cinema • Indian Showcase • Focus North East India • <span className="text-red-500 font-semibold">Indian Shorts • Asian Shorts</span>
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
              <a
                href="https://filmfreeway.com/GuwahatiAsianFilmFestival"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  size="lg"
                  className="bg-white text-black hover:bg-red-500 hover:text-white transition-all duration-300 px-6 sm:px-8 py-3 sm:py-4 md:py-6 text-sm sm:text-base md:text-lg w-full sm:w-auto">
                  Submit Your Short
                </Button>
              </a>
              <div className="flex flex-col">
                <div className="text-3xl sm:text-4xl font-bold">{featuredFilm.rating}</div>
                <div className="text-sm text-gray-400"></div>
                <div className="text-xs text-gray-500">
                  {featuredFilm.totalRatings} 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Background Image - Right Side */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1/3 h-2/3 opacity-30 blur-sm hidden md:block">
        <img
          src="https://images.unsplash.com/photo-1758786266368-30dd993cfdaf"
          alt="Background"
          className="w-full h-full object-cover rounded-l-3xl" />

      </div>
    </section>);

};

export default FeaturedSection;